module.exports = __webpack_public_path__ + "img/SES_4069007860.0474eff4.jpg";